export default "__VITE_ASSET__CNeIl1Tt__"